module.exports = __webpack_public_path__ + "static/interstate-light-a152708d24b793e607ef42703d1be072.woff2";